var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessageInputBoxSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 30 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414042",
    d: "M29.698.237a.749.749 0 00-.79-.132L.459 12.085a.749.749 0 00.054 1.4l8.472 2.824v8.445a.749.749 0 001.33.472l4.138-5.092 6.734 6.65a.749.749 0 001.245-.321l7.487-25.456a.749.749 0 00-.22-.77zm-5.545 3.496l-14.56 11.2-6.721-2.24 21.281-8.96zM10.482 16.138L24.58 5.293 13.808 18.552l-.001.001-3.325 4.092v-6.507zm10.865 8.7L15.4 18.967 27.43 4.162l-6.082 20.677z"
  })));
}

export default SvgMessageInputBoxSend;